import {href, useMatch} from 'react-router';

export const useShouldSkipInitScripts = () => {
  const payWallStandalonePage = Boolean(useMatch(href('/pay-wall-standalone')));
  const checkoutHandoffPage = Boolean(useMatch(href('/checkout-handoff')));
  const checkoutHandoffErrorPage = Boolean(
    useMatch(href('/checkout-handoff-error'))
  );
  const cypressEnv = typeof window !== 'undefined' && Boolean(window.Cypress);

  return (
    cypressEnv ||
    payWallStandalonePage ||
    checkoutHandoffPage ||
    checkoutHandoffErrorPage
  );
};
